import { FormControl, Select, MenuItem, useTheme } from "@mui/material";

export const SortResultsMenu = ({ sortBy, setSortBy, sortOptions }) => {
  const theme = useTheme();

  return (
    <FormControl
      fullWidth
      focused={false}
      variant="outlined"
      sx={{
        color: theme.palette.primary.mainText,
      }}
    >
      <Select
        sx={{
          borderRadius: "45px",
          height: "44px",
          paddingLeft: "5px",
          paddingRight: "5px",
          color: theme.palette.primary.mainText,
          backgroundColor: "transparent",
          transition: "250ms ease-in-out",
          bgcolor: theme.palette.secondary.background,
          "&:hover": {
            bgcolor: "rgba(0,0,0,0.02)",
            boxShadow: theme.shadows[3],
          },
        }}
        placeholder=""
        value={sortBy}
        onChange={(e) => {
          setSortBy(e.target.value);
        }}
        displayEmpty
        variant="outlined"
        autoWidth
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: "white",
              "& .MuiMenuItem-root": {
                padding: 2,
              },
              borderRadius: "10px",
            },
          },
        }}
      >
        {sortOptions.map((c, idx) => (
          <MenuItem
            value={idx}
            key={idx + c.label}
            sx={{ color: theme.palette.primary.mainText, width: "175px" }}
          >
            {c.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
